module.exports = __webpack_public_path__ + "img/time-line.004c3d64.svg";